var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 980 1080"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bg-right_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 131",
    transform: "translate(860 416)",
    stroke: "#707070",
    fill: "url(#bg-right_svg__a)",
    d: "M0 0h980v664H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg-right_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    transform: "translate(.461 .131)",
    fill: "url(#bg-right_svg__a)",
    d: "M0 0h2337v2123H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg-right_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 132",
    transform: "translate(1547)",
    fill: "#fac9a5",
    stroke: "#707070",
    d: "M0 0h373v1080H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg-right_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    transform: "translate(.461)",
    fill: "#fac9a5",
    d: "M0 0h2079v1887H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-right_svg__a",
    x1: 0.5,
    x2: 0.496,
    y2: 0.313,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7ccad",
    stopOpacity: 0.322
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#f7ccad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ccad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40606"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1",
    transform: "translate(-860)",
    opacity: 0.32,
    clipPath: "url(#bg-right_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1",
    transform: "translate(815.539 415.868)",
    clipPath: "url(#bg-right_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M1882.56 174.839S1781.662 0 1579.873 0H758.312s-201.8 0-302.687 174.839L44.844 886.4s-100.9 174.747 0 349.494l410.781 711.565s100.89 174.747 302.687 174.747h821.561s201.789 0 302.687-174.747l410.781-711.559s100.9-174.747 0-349.494z",
    transform: "translate(-1.169 -.412)",
    fill: "url(#bg-right_svg__a)"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 2",
    opacity: 0.48,
    clipPath: "url(#bg-right_svg__d)",
    transform: "translate(-940)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1",
    transform: "translate(1546.539 -143)",
    clipPath: "url(#bg-right_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M1674.086 155.452S1584.372 0 1404.963 0H674.499S495.078 0 405.372 155.452L40.144 788.116s-89.711 155.371 0 310.741l365.228 632.663s89.7 155.37 269.124 155.37h730.463s179.413 0 269.124-155.37l365.232-632.664s89.711-155.37 0-310.741z",
    fill: "#fac9a5"
  })))))));
}
export default SvgBgRight;